import { render } from "./CreditView.vue?vue&type=template&id=920c40e8"
import script from "./CreditView.vue?vue&type=script&lang=js"
export * from "./CreditView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__